import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { Localize } from "components/service";


// Click-triggered tooltips prevent Link navigation in this Ant Design version.
const StaffWorkerTooltip = ({ translationKey, children, trigger = [ "hover", "focus" ] }) => {
    const [ visible, setVisible ] = useState(false);

    useEffect(() => {
        if (!visible) return;

        const dismiss = (event) => {
            if (event.key === "Escape") setVisible(false);
        };

        document.addEventListener("keydown", dismiss);
        return () => document.removeEventListener("keydown", dismiss);
    }, [ visible ]);

    return (
        <Tooltip
            title={ <Localize>{ translationKey }</Localize> }
            trigger={ trigger }
            visible={ visible }
            onVisibleChange={ setVisible }>
            { children }
        </Tooltip>
    );
};

export default StaffWorkerTooltip;
